import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Input, ViewChild, inject } from '@angular/core';
import { isTouchDevice } from '@iris/common/utils/touch.utils';
import { TranslateModule } from '@ngx-translate/core';
import { NgxTippyModule, NgxTippyProps } from 'ngx-tippy-wrapper';

@Component({
  selector: 'iris-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxTippyModule,
    TranslateModule,
  ],
})
export class IrisInfoIconComponent implements AfterViewInit {
  private readonly changeDetector = inject(ChangeDetectorRef);

  @ViewChild('icon') icon: ElementRef;

  @Input() message = '';
  @Input() disabled = false;

  @HostBinding('class.d-none') get hidden(): boolean {
    return !this.message;
  }

  readonly tooltipProps: NgxTippyProps = {
    arrow: true,
    maxWidth: '500px',
    trigger: this.triggers,
    theme: 'light-border',
    appendTo: document.body,
  };

  get triggers(): string {
    return this.isTouch() ? 'click focus' : 'mouseenter focus';
  }

  isTouch(): boolean {
    return isTouchDevice();
  }

  setMessage(propInfo: string): void {
    this.message = propInfo;
    this.changeDetector.markForCheck();
  }

  ngAfterViewInit(): void {
    if (this.disabled) {
      this.icon.nativeElement.setAttribute('disabled', '');
    };
  }
}
